









































































































































































import { Vue, Component, Mixins } from 'vue-property-decorator';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import ArticleGridColumn from '@/components/board/mixins/ArticleGridColumn';
import { ncpPopup } from '@/utils/ncp';
import { State } from 'vuex-class';
import { Mall } from 'supporter';
import { getToday, addMonth } from '@/utils/dateUtils';
import ExcelCreateButton from '@/components/common/grid/ExcelCreateButton.vue';
import { GetBoardsBoardNoPostsPostNoRepliesRequest } from 'ncp-api-supporter/dist/types';
import { ArticlesExcelRequest } from '@/types';
import { createExcel } from '@/components/common/grid/ExcelCreateUtil';

@Component({
  components: {
    PageTitle,
    PeriodDateCalendar,
    ItemTable,
    ExcelCreateButton,
  },
})
export default class ArticleList extends Mixins(ArticleGridColumn) {
  @State('malls', { namespace: 'mall' })
  private malls!: Mall[];

  private articleList: any[] = [];
  private replyArticleList: any[] = [];
  private replyAvailable: any = {};
  private totalCount: number = 0;
  private page: number = 1;
  private size: number = 30;
  private parentArticleNo: string = '';
  private boards: any[] = [];
  private theForm: any = {
    mallNo: 0,
    boardNo: 0,
    categoryNo: '',
    searchType: 'ALL',
    keyword: '',
    noticed: null,
    startYmdt: addMonth(new Date(), -3),
    endYmdt: getToday(),
  };
  private showReplyPopup: boolean = false;
  private memberGroupData: any = {
    id: 'reply',
    width: 1300,
    maxHeight: 1200,
    title: 'BOARD_ARTICLE_LIST_REPLY_SEARCH',
    nonFooter: false,
    hasConfirmBtn: false,
  };
  private articlesOption = {
    haveConfigBtn: false,
    haveExcelDownBtn: false,
    onLoadSearch: false,
    pageSize: 30,
  };
  private gridProps: any = {
    header: {
      height: 33,
    },
    options: {
      rowHeaders: ['checkbox'],
      pageOptions: {
        perPage: 1,
        page: 1,
        totalCount: 10,
      },
      columnOptions: {
        minWidth: 50,
        resizable: true,
      },
      minRowHeight: 32,
      rowHeight: 32,
      bodyHeight: 190,
      isInitialRequest: true,
      useClientSort: false,
    },
    columns: [],
  };
  private gridPropsColumns = [
    'index',
    'mallName',
    'no',
    'board',
    'categoryNo',
    'title',
    'opened',
    'replyCount',
    'secreted',
    'recommendCount',
    'readCount',
    'writeAdmin',
    'creationDateTime',
    'editor',
    'modificationDateTime',
  ];
  private replyGridOption: any = {
    name: 'reply',
    noBorder: true,
    haveRigthBtn: false,
    nonDataBodyHeight: 190,
    haveDataBodyHeight: 337,
    pageSize: 10,
  };
  private replyGridProps: any = {
    options: {
      header: {
        height: 33,
      },
      columnOptions: {
        minWidth: 50,
      },
      minRowHeight: 31,
      rowHeight: 31,
      bodyHeight: 190,
      isInitialRequest: true,
      useClientSort: false,
      rowHeaders: ['checkbox', 'rowNum'],
      pageOptions: {
        perPage: 10,
        page: 1,
        totalCount: 10,
      },
    },
    columns: [],
  };
  private replyGridPropsColumns = [
    'mallName',
    'replyNo',
    'board',
    'categoryNo',
    'replyTitle',
    'opened',
    'replyYn',
    'secreted',
    'writeAdmin',
    'creationDateTime',
    'editor',
    'modificationDateTime',
  ];
  private articleExcelModelList = [
    'mallName',
    'no',
    'board',
    'categoryNo',
    'title',
    'opened',
    'replyCount',
    'secreted',
    'readCount',
    'writeAdminForExcel',
    'creationDateTime',
    'modifyAdminForExcel',
    'modificationDateTime',
  ];
  private allExcelModelList = [
    'mallName',
    'no',
    'board',
    'categoryNo',
    'title',
    'opened',
    'replyCount',
    'replyYnForExcel',
    'secreted',
    'readCount',
    'writeAdminForExcel',
    'creationDateTime',
    'modifyAdminForExcel',
    'modificationDateTime',
  ];
  private theExcelDownIfo: any = {
    fileName: '',
    columns: {},
    formatters: {},
  };
  private theAllExcelDownIfo: any = {
    fileName: '',
    columns: {},
    formatters: {},
  };
  private initGrids(): void {
    this.gridPropsColumns.forEach((item: any) => {
      let key: any;
      for (key in this.articleGridColumn) {
        if (item === key) {
          this.gridProps.columns.push(this.articleGridColumn[key]);
        }
      }
    });
    this.replyGridPropsColumns.forEach((item: any) => {
      let key: any;
      for (key in this.articleGridColumn) {
        if (item === key) {
          this.replyGridProps.columns.push(this.articleGridColumn[key]);
        }
      }
    });
    this.initExcelColums();
  }
  private initExcelColums(): void {
    this.articleExcelModelList.forEach((el: any): any => {
      this.theExcelDownIfo.columns[el] = this.articleGridColumn[el].header;
      if (el !== 'no' && el !== 'title' && el !== 'replyCount') {
        if (el === 'categoryNo') {
          this.theExcelDownIfo.formatters[el] = (data: any): any => {
            if (data.row.category) {
              return `${data.row.category.name}`;
            }
          };
        } else {
          this.theExcelDownIfo.formatters[el] = this.articleGridColumn[el].formatter;
        }
      }
    });
    this.allExcelModelList.forEach((el: any): any => {
      this.theAllExcelDownIfo.columns[el] = this.articleGridColumn[el].header;
      if (el !== 'no' && el !== 'title' && el !== 'replyCount') {
        if (el === 'categoryNo') {
          this.theAllExcelDownIfo.formatters[el] = (data: any): any => {
            if (data.row.category) {
              return `${data.row.category.name}`;
            }
          };
        } else {
          this.theAllExcelDownIfo.formatters[el] = this.articleGridColumn[el].formatter;
        }
      }
    });
    this.theExcelDownIfo.fileName = 'board_article';
    this.theAllExcelDownIfo.fileName = 'all_board_article';
  }

  private getExcelParamRequest: ArticlesExcelRequest = {
    params: {
      mallNo: this.theForm.mallNo,
      categoryNo: this.theForm.categoryNo,
      noticed: this.theForm.noticed ? this.theForm.noticed : null,
      searchType: this.theForm.searchType,
      keyword: this.theForm.keyword,
      startDateTime: this.theForm.startYmdt + ' 00:00:00',
      endDateTime: this.theForm.endYmdt + ' 23:59:59',
      page: 1,
      pageSize: null,
      includeReplies: true,
    },
  };

  private async getExcelRequestResult() {
    let excelOutPutList = [];
    let excelRequestParam = {
      pathParams: {
        boardNo: this.theForm.boardNo,
      },
      params: {
        mallNo: this.theForm.mallNo,
        categoryNo: this.theForm.categoryNo,
        noticed: this.theForm.noticed ? this.theForm.noticed : null,
        searchType: this.theForm.searchType,
        keyword: this.theForm.keyword,
        startDateTime: this.theForm.startYmdt + ' 00:00:00',
        endDateTime: this.theForm.endYmdt + ' 23:59:59',
        page: 1,
        pageSize: 10000,
        includeReplies: true,
      },
    };
    const res = await this.$api.getBoardsBoardNoPosts(excelRequestParam);
    res.data.contents.forEach((elem: any, index: any) => (elem.index = index + 1));
    excelOutPutList = res.data.contents;
    return excelOutPutList;
  }

  private handleExcelDownloadClick(type: string = '') {
    const hasData = this.articleList.length > 0;
    const requestParams = Object.assign(this.getExcelParamRequest.params);
    if(type === 'all'){
      createExcel(this, hasData, requestParams, 'PREMIUM_ARTICLE_LIST_TOTAL', this.theForm.boardNo);
      return;
    }
    const withoutRepliesRequestParams = {...requestParams, includeReplies: false}
    createExcel(this, hasData, withoutRepliesRequestParams, 'PREMIUM_ARTICLE_LIST', this.theForm.boardNo);
  }

  private searchBtnClick() {
    this.page = 1;
    this.getArticles();
  }
  private getArticles(page?: number, size?: number) {
    if (!this.theForm.mallNo) return;
    if (!this.checkform()) return;
    this.articleList = [];
    let obj = {
      pathParams: {
        boardNo: this.theForm.boardNo,
      },
      params: {
        mallNo: this.theForm.mallNo,
        categoryNo: this.theForm.categoryNo,
        noticed: this.theForm.noticed ? this.theForm.noticed : null,
        searchType: this.theForm.searchType,
        keyword: this.theForm.keyword,
        startDateTime: this.theForm.startYmdt + ' 00:00:00',
        endDateTime: this.theForm.endYmdt + ' 23:59:59',
        page: page ? page : 1,
        pageSize: size ? size : (this.$refs.theGird as any).itemInfo.pageSize,
      },
    };

    Object.assign(this.getExcelParamRequest.params, obj.params);
    delete this.getExcelParamRequest.params.pageSize;

    this.$api.getBoardsBoardNoPosts(obj).then((res: any) => {
      res.data.contents.forEach((elem: any, index: any) => (elem.index = index + 1));
      this.articleList = res.data.contents;
      this.totalCount = res.data.totalCount;
      this.gridProps.options.pageOptions.perPage = obj.params.pageSize;
      this.gridProps.options.pageOptions.page = obj.params.page;
    });
  }
  private getReplyAvailability() {
    this.boards.map((item: any) => {
      this.replyAvailable[item.boardNo] = item.replyUsed;
    });
  }
  private checkform() {
    if (this.theForm.searchType !== 'ALL' && this.theForm.keyword.length === 0) {
      window.alert(this.$t('BOARD_ARTICLE_LIST_ENTER_SEARCH_WORD'));
      $('#search_text').focus();
      return false;
    }
    return true;
  }
  private resetSearchForm() {
    this.theForm = {
      mallNo: this.malls[0].mallNo,
      boardNo: 0,
      categoryNo: '',
      searchType: 'ALL',
      keyword: '',
      noticed: null,
      startYmdt: addMonth(new Date(), -3),
      endYmdt: getToday(),
    };
    (this.$refs.datePicker as any).calendarInfo.period = '3m';

    this.changeMall();
  }
  private changeMall() {
    let obj = {
      params: {
        mallNo: this.theForm.mallNo,
      },
    };
    this.$api.getBoards(obj).then((res: any) => {
      this.boards = res.data;
      if (this.boards.length) {
        this.boards = this.boards.reverse();
      }
      const boardSelect = document.querySelector('#board') as any;
      while (boardSelect.firstChild) {
        boardSelect.removeChild(boardSelect.firstChild);
      }
      if (this.boards.length) {
        boardSelect.removeAttribute('disabled');
        boardSelect.insertAdjacentHTML(
          'afterbegin',
          this.boards.map(board => `<option value='${board.boardNo}'>${board.boardName}</option>`).join(''),
        );
        this.theForm.boardNo = this.boards[0].boardNo;
      } else {
        boardSelect.setAttribute('disabled', '');
        const categorySelect = $('#category');
        categorySelect.attr('disabled', 'disabled');
        this.articleList = [];
        this.totalCount = 0;
        return;
      }
      this.getReplyAvailability();
      this.changeBoard();
      this.getArticles();
    });
  }
  private changeBoard() {
    this.theForm.categoryNo = '';
    const [selectedBoard] = this.boards.filter(board => board.boardNo == this.theForm.boardNo);

    const categorySelect = $('#category');
    categorySelect.text('');
    categorySelect.append(`<option value="">${window.$t('BOARD_ARTICLE_LIST_CATEGORY_ALL')}</option>`);
    if (selectedBoard && selectedBoard.categoryUsed) {
      categorySelect.removeAttr('disabled');
      selectedBoard.categories
        .sort((a, b) => {
          if (a.categoryNo < b.categoryNo) return -1;
          else if (a.categoryNo > b.categoryNo) return 1;
          else return 0;
        })
        .forEach((category: any) => {
          categorySelect.append(`<option value='${category.categoryNo}'>${category.categoryName}</option>`);
        });
    } else {
      categorySelect.attr('disabled', 'disabled');
    }
  }
  private clickDeleteBtn() {
    const selectedArticles = (this.$refs.theGird as any).getCheckedRowKeys();
    if (selectedArticles.length === 0) {
      window.alert(this.$t('BOARD_ARTICLE_LIST_SELECT_ARTICLE'));
      return false;
    }
    const param = selectedArticles.map((key: any) => (this.$refs.theGird as any).getRowAt(key).no).join(',');
    this.deleteArticle(param, false);
    return true;
  }
  private deleteArticle(selectedArticles: any, isReply: any) {
    if (!window.confirm(this.$t('BOARD_ARTICLE_LIST_CONFIRM_DELETE_ARTICLE') as any)) {
      return false;
    }
    let obj = {
      pathParams: {
        boardNo: this.theForm.boardNo,
      },
      params: {
        postNos: selectedArticles,
      },
    };
    this.$api.deleteBoardsBoardNoPosts(obj).then(() => {
      window.alert(this.$t('BOARD_ARTICLE_LIST_COMPLETE_DELETE'));
      if (isReply) {
        this.getReplies();
      }
      this.getArticles();
    });
    return true;
  }
  private clickMoveBtn() {
    const mallNo = this.theForm.mallNo;
    const selectedNumbers = (this.$refs.theGird as any).getCheckedRowKeys();
    if (selectedNumbers.length === 0) {
      window.alert(this.$t('BOARD_ARTICLE_LIST_SELECT_ARTICLE'));
      return false;
    }
    const queryString = selectedNumbers.map((key: any) => (this.$refs.theGird as any).getRowAt(key).no).join(',');
    const boardNo = selectedNumbers.map((key: any) => (this.$refs.theGird as any).getRowAt(key).boardNo)[0];
    (window as any).articleMoveCallback = this.articleMoveCallback;
    let name = '';
    if (selectedNumbers.length === 1) {
      name = this.articleList.filter((item: any) => item.no == queryString)[0].title;
    } else {
      name = selectedNumbers.length + '건';
    }
    const url = `/board/popup/article/move?name=${name}&articleNumbers=${queryString}&mallNo=${mallNo}&callback=articleMoveCallback&boardNo=${boardNo}`;
    ncpPopup(url, window.$t('BOARD_ARTICLE_LIST_BTN_MOVE'), 670, 350);

    return true;
  }
  private articleMoveCallback() {
    this.getArticles();
  }
  private clickAddBtn() {
    const mallNo = $('[name=mallNo]').val();
    (window as any).addPopupCallback = this.addPopupCallback;
    const url = `/board/popup/article/form?mallNo=${mallNo}&replyYn=false&callback=addPopupCallback`;
    ncpPopup(url, window.$t('BOARD_ARTICLE_LIST_NEW_ARTICLE'), 1036, 750);
  }
  private addPopupCallback(response: any, isReplyUpdate: any) {
    if (isReplyUpdate) {
      this.getReplies();
    }
    this.getArticles();
  }

  private getReplies(page: number = 1, pageSize: number = 10, categoryName: string = '') {
    const request: GetBoardsBoardNoPostsPostNoRepliesRequest = {
      pathParams: {
        boardNo: this.theForm.boardNo,
        postNo: Number(this.parentArticleNo),
      },
      params: {
        mallNo: this.theForm.mallNo,
        page,
        pageSize,
      },
    };
    this.$api.getBoardsBoardNoPostsPostNoReplies(request).then((res: any) => {
      let result = [...res.data.contents];
      result.forEach(v => {
        v.category = { name: '' };
        v.category.name = categoryName;
      });
      this.replyArticleList = result;
      localStorage.removeItem('articleRepliesInfo');
      localStorage.setItem('articleRepliesInfo', JSON.stringify(result));
      this.replyGridProps.options.pageOptions.totalCount = res.data.totalCount;
    });
  }
  private clickAddReplyBtn() {
    const selectedNumbers = (this.$refs.theGird as any).getCheckedRowKeys();
    if (selectedNumbers.length === 0) {
      window.alert(this.$t('BOARD_ARTICLE_LIST_SELECT_ARTICLE'));

      return false;
    }
    if (selectedNumbers.length > 1) {
      window.alert(this.$t('BOARD_ARTICLE_LIST_MULTI_SELECT'));

      return false;
    }

    const article = (this.$refs.theGird as any).getRowAt(selectedNumbers[0]);
    if (article.parentBoardArticle) {
      window.alert(this.$t('BOARD_ARTICLE_LIST_REPLY_DEPTH'));

      return false;
    }

    const boardNo = article.boardNo;
    if (!this.replyAvailable[boardNo]) {
      window.alert(this.$t('BOARD_ARTICLE_LIST_REPLY_PERMISSION'));

      return false;
    }
    const mallNo = $('[name=mallNo]').val();
    let obj = {
      pathParams: {
        boardNo: this.theForm.boardNo,
        postNo: article.no,
      },
      params: {
        mallNo: this.theForm.mallNo,
      },
    };
    this.$api.getBoardsBoardNoPostsPostNo(obj).then((res: any) => {
      Vue.set(res.data, 'mallNo', this.theForm.mallNo);
      localStorage.removeItem('articleDetail');
      localStorage.setItem('articleDetail', JSON.stringify(res.data));
      (window as any).addPopupCallback = this.addPopupCallback;
      const url = `/board/popup/article/form?mallNo=${mallNo}&boardNo=${boardNo}&parentArticleNo=${article.no}&callback=addPopupCallback`;
      ncpPopup(url, window.$t('BOARD_ARTICLE_LIST_ADD_REPLY'), 1050, 850);
    });

    return true;
  }
  private articlePopup(articleNo: any) {
    let obj = {
      pathParams: {
        boardNo: this.theForm.boardNo,
        postNo: articleNo,
      },
      params: {
        mallNo: this.theForm.mallNo,
      },
    };
    this.parentArticleNo = articleNo;
    this.$api.getBoardsBoardNoPostsPostNo(obj).then((res: any) => {
      Vue.set(res.data, 'mallNo', this.theForm.mallNo);
      localStorage.removeItem('articleDetail');
      localStorage.setItem('articleDetail', JSON.stringify(res.data));
      (window as any).addPopupCallback = this.addPopupCallback;
      const url = `/board/popup/article/${articleNo}/form?callback=addPopupCallback`;
      ncpPopup(url, window.$t('BOARD_ARTICLE_LIST_MODIFY_ARTICLE'), 1045, 850);
    });
  }

  private articleReplyPopup(articleNo: any) {
    let obj = {
      pathParams: {
        boardNo: this.theForm.boardNo,
        postNo: articleNo,
      },
      params: {
        mallNo: this.theForm.mallNo,
      },
    };
    this.parentArticleNo = articleNo;

    this.$api.getBoardsBoardNoPostsPostNo(obj).then((res: any) => {
      Vue.set(res.data, 'mallNo', this.theForm.mallNo);
      localStorage.removeItem('articleDetail');
      localStorage.setItem('articleDetail', JSON.stringify(res.data));
      (window as any).addReplyPopupCallback = this.addReplyPopupCallback;
      let parentArticleNo = JSON.parse(localStorage.getItem('replyParentArticleNo'));
      const url = `/board/popup/article/${articleNo}/form?mode=replyUpdate&parentArticleNo=${parentArticleNo}&callback=addReplyPopupCallback`;
      ncpPopup(url, window.$t('BOARD_ARTICLE_LIST_MODIFY_ARTICLE'), 1045, 850);
    });
  }
  private addReplyPopupCallback(response: any, isReplyUpdate: any) {
    if (isReplyUpdate) {
      this.getReplies();
      let replyParentArticleNo = JSON.parse(localStorage.getItem('replyParentArticleNo'));
      let categoryName = JSON.parse(localStorage.getItem('parentCategoryName'));
      this.getlayerReplies(replyParentArticleNo, categoryName);
    }
    this.getArticles();
    (window as any).addReplyPopupCallback = undefined;
  }
  private getlayerReplies(articleNo: any, categoryName?: any) {
    let obj = {
      pathParams: {
        boardNo: this.theForm.boardNo,
        postNo: articleNo,
      },
      params: {
        mallNo: this.theForm.mallNo,
      },
    };
    this.$api.getBoardsBoardNoPostsPostNoReplies(obj).then((res: any) => {
      let result = [...res.data.contents];
      result.forEach(v => {
        v.category = { name: '' };
        v.category.name = categoryName;
      });
      this.replyArticleList = result;
      localStorage.removeItem('articleRepliesInfo');
      localStorage.setItem('articleRepliesInfo', JSON.stringify(result));
      this.replyGridProps.options.pageOptions.totalCount = res.data.totalCount;
    });
  }
  private onClickReplyCnt(e: any) {
    const articleNo = $(e.target)
      .parents('tr')
      .find('.articleNo')
      .data('article-no');
    this.parentArticleNo = articleNo;
    const categoryName =
      $(e.target)
        .parents('tr')
        .find('.categoryName')
        .data('category-name') ?? '';

    localStorage.removeItem('replyParentArticleNo');
    localStorage.setItem('replyParentArticleNo', JSON.stringify(articleNo));
    localStorage.removeItem('parentCategoryName');
    localStorage.setItem('parentCategoryName', JSON.stringify(categoryName));
    this.showReply(categoryName);
  }
  private async showReply(categoryName: string) {
    await this.getReplies(1, 10, categoryName);
    this.showReplyPopup = true;
  }
  private clickReplyDeleteBtn() {
    const selectedArticles = (this.$refs.replyGrid as any).getCheckedRowKeys();
    if (selectedArticles.length === 0) {
      window.alert(this.$t('BOARD_ARTICLE_LIST_SELECT_ARTICLE'));
      return false;
    }
    const param = selectedArticles.map((key: any) => (this.$refs.replyGrid as any).getRowAt(key).no).join(',');
    this.deleteArticle(param, true);
    return true;
  }
  private initData() {
    this.theForm.mallNo = this.malls[0].mallNo;
    this.changeMall();
  }
  private created() {
    this.initGrids();
  }
  private mounted() {
    this.initData();
    (window as any).articlePopup = this.articlePopup;
    (window as any).articleReplyPopup = this.articleReplyPopup;
    $('body').on('click', '.replyCnt', $.proxy(this.onClickReplyCnt, this));
  }
  private destroyed(): void {
    $('body').off('click', '.replyCnt', $.proxy(this.onClickReplyCnt, this));
  }
}
